module.exports = __webpack_public_path__ + "img/3_香港1.6f8e4f73.jpg";